import { NgModule } from "@angular/core";
import { MedIconHomeModule } from "@mk/med-icons";

import { BreadcrumbsComponent } from "./breadcrumbs.component";
import {NgForOf, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";

@NgModule({
  declarations: [BreadcrumbsComponent],
  imports: [MedIconHomeModule, NgForOf, NgIf, RouterLink],
  exports: [BreadcrumbsComponent],
})
export class BreadcrumbsModule {}
